// Loads and parses Markdown documentation files as the Single Source of Truth
import { parseMarkdownDoc } from "./markdownParser";

import doc01 from "./01-market-structure.md";
import doc05 from "./05-levels-quality.md";
import doc06 from "./06-key-levels.md";
import doc15 from "./15-market-structure-2.md";
import doc16 from "./16-price-quality.md";
import doc17 from "./17-market-internals.md";
import doc20 from "./20-order-book.md";
import doc21 from "./21-who-moves-the-market.md";
import doc22 from "./22-liquidity.md";
import doc23 from "./23-supply-demand-zone.md";
import doc24 from "./24-patterns-candles-chart.md";
import doc25 from "./25-market-cycles.md";
import doc26 from "./26-price-derived-metrics.md";
import doc27 from "./27-volatility-grid.md";
import doc29 from "./29-timeframes.md";
import doc30 from "./30-trade-plan-concise.md";
import doc31 from "./31-trade-management.md";
import doc32 from "./32-trade-plan.md";
import doc33 from "./33-pre-trade-plan.md";

export const MARKDOWN_DOC_SOURCES = [
    { id: "pre_trade_plan", url: doc33 },
    { id: "trade_plan", url: doc32 },
    { id: "trade_plan_concise", url: doc30 },
    { id: "trade_management", url: doc31 },
    { id: "order_book", url: doc20 },
    { id: "market_flows", url: doc21 },
    { id: "liquidity", url: doc22 },
    { id: "timeframes", url: doc29 },
    { id: "market_cycles", url: doc25 },
    { id: "price_quality", url: doc16 },
    { id: "market_structure", url: doc01 },
    { id: "market_structure_2", url: doc15 },
    { id: "patterns_candles_chart", url: doc24 },
    { id: "levels_quality", url: doc05 },
    { id: "key_levels", url: doc06 },
    { id: "supply_demand_zone", url: doc23 },
    { id: "contextual_filters", url: doc17 },
    { id: "price_derived_metrics", url: doc26 },
    { id: "volatility_grid", url: doc27 }
];

export const DEFAULT_DICTIONARY_CATEGORIES = [
    "Playbook",
    "Market Foundations",
    "Market Context",
    "Key Price Zones",
    "Market Confluence"
];

/**
 * Asynchronously loads and parses all Markdown concept files.
 */
export async function loadMarkdownDictionary() {
    try {
        const parsedDocs = await Promise.all(
            MARKDOWN_DOC_SOURCES.map(async ({ id, url }) => {
                const safeUrl = url.startsWith('/') || url.startsWith('http') ? url : `/${url}`;
                const res = await fetch(safeUrl);
                if (!res.ok) throw new Error(`HTTP ${res.status} loading ${safeUrl}`);
                const text = await res.text();
                if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
                    throw new Error(`Received HTML instead of markdown for ${safeUrl}`);
                }
                return parseMarkdownDoc(text, id);
            })
        );
        return parsedDocs.filter(Boolean);
    } catch (err) {
        console.error("Error loading markdown dictionary docs:", err);
        return [];
    }
}
